module.exports = __webpack_public_path__ + "img/c3f5e89680abeafb030decf5621edc91.c3f5e896.png";